module.exports = "/_next/static/images/excellent-f8adfa6b112e7aee6dd7ee409e64c89e.png";